"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.base64ToBuffer = exports.bufferToBase64 = exports.rsaBufferTokeyId = exports.getBrowserRsaParams = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var bufferToBase64 = function bufferToBase64(arrayBuffer) {
  return window.btoa(String.fromCharCode.apply(String, _toConsumableArray(new Uint8Array(arrayBuffer))));
};

exports.bufferToBase64 = bufferToBase64;

var base64ToBuffer = function base64ToBuffer(b64str) {
  var binary = window.atob(b64str);
  var len = binary.length;
  var bytes = new Uint8Array(len);

  for (var i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes.buffer;
};

exports.base64ToBuffer = base64ToBuffer;

var getBrowserRsaParams = function getBrowserRsaParams(rsaKeySize) {
  return {
    name: 'RSA-OAEP',
    modulusLength: rsaKeySize,
    publicExponent: new Uint8Array([1, 0, 1]),
    hash: 'SHA-256'
  };
};

exports.getBrowserRsaParams = getBrowserRsaParams;

var rsaBufferTokeyId = function rsaBufferTokeyId(pubKey, privKey) {
  return "".concat(bufferToBase64(pubKey), ".").concat(bufferToBase64(privKey));
};

exports.rsaBufferTokeyId = rsaBufferTokeyId;